module.exports = __webpack_public_path__ + "media/images/area/area_mieM400-5c46e01d3ba3167431c88af44a12a5f1.jpg";